import React, { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { IonCard, IonCardContent, IonCol, IonRow } from "@ionic/react";

function createHtml(html) {
  return {
    __html: html,
  };
}

const FAQs = ({ FAQS }) => {
  const accordionRef = useRef(null);

  useEffect(() => {
    const accordion = accordionRef.current;
    if (!accordion) return;

    // Handle aria-hidden for collapsed accordion panels
    const handleShow = (event) => {
      event.target.removeAttribute("aria-hidden");
    };

    const handleHide = (event) => {
      event.target.setAttribute("aria-hidden", "true");
    };

    accordion.addEventListener("show.bs.collapse", handleShow);
    accordion.addEventListener("hidden.bs.collapse", handleHide);

    return () => {
      accordion.removeEventListener("show.bs.collapse", handleShow);
      accordion.removeEventListener("hidden.bs.collapse", handleHide);
    };
  }, []);

  return (
    <>
      <IonRow style={{ marginBottom: "20px" }}>
        <IonCol size="12" sizeXl="10" offsetXl="1">
          <IonRow>
            <IonCol>
              <h2
                className="home"
                style={{
                  marginTop: "10px",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                Frequently Asked <strong>Questions</strong>
              </h2>
              <IonCard className="card-margin">
                <IonCardContent>
                  <div className="accordion" id="accordionExample" ref={accordionRef}>
                    {FAQS.map((faq) => (
                      <div className="accordion-item" key={faq.id}>
                        <h3
                          className="accordion-header"
                          id={`heading${faq.id}`}
                        >
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${faq.id}`}
                            aria-expanded="false"
                            aria-controls={`collapse${faq.id}`}
                          >
                            {faq.question}
                          </button>
                        </h3>
                        <div
                          id={`collapse${faq.id}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`heading${faq.id}`}
                          data-bs-parent="#accordionExample"
                          aria-hidden="true"
                        >
                          <div
                            className="accordion-body"
                            dangerouslySetInnerHTML={createHtml(faq.answer)}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonCol>
      </IonRow>
    </>
  );
};

export default FAQs;
